import Vue from "vue";

Vue.filter('yesNo', (val: unknown) => {
  return val ? "Ja" : "Nein";
});
